module.exports = __webpack_public_path__ + "img/delivery-detail-normal.be4805f5.svg";